// Utilidades matemáticas para el quiz
// Función para calcular porcentajes
export const calcularPorcentaje = (valor, total) => {
  if (total === 0) return 0;
  const porcentaje = (valor / total) * 100;
  return Number.isFinite(porcentaje) && porcentaje >= 0 ? Math.round(porcentaje) : 0;
};

// Función para formatear tiempo en formato MM:SS
export const formatearTiempo = (segundos) => {
 const minutos = Math.floor(segundos / 60);
  const segundosRestantes = segundos % 60;
  return `${minutos}:${segundosRestantes.toString().padStart(2, '0')}`;
};
